<template>
    <div style="height: 350px">
        <el-form :model="formData" ref="formRef" label-width="140px" size="mini">
            <el-form-item  prop="pzcode" label="物料数字代码">
                <el-input v-model="formData.pzcode"  size="mini" class="input" ></el-input>
            </el-form-item>
            <el-form-item  prop="supplier" label="厂家名称">
                <el-input v-model="formData.supplier"  size="mini" class="input" ></el-input>
            </el-form-item>
            <el-form-item  prop="suppliercode" label="厂家代码">
                <el-input v-model="formData.suppliercode"  size="mini" class="input" ></el-input>
            </el-form-item>
            <el-form-item  prop="lruname" label="录入人">
                <el-input v-model="formData.lruname" :disabled="true" size="mini" class="input" ></el-input>
            </el-form-item>
            <el-form-item  prop="createTime" label="创建时间">
                <el-input v-model="formData.createtime" :disabled="true" size="mini" class="input" ></el-input>
            </el-form-item>
            <el-form-item  prop="gid" label="归属组">
                <el-select v-model="formData.gid" size="mini" clearable >
                    <el-option v-for="item in gszList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center">
            <template >
                <el-button type="primary" @click="saveForm" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="canEdit">保存</el-button>
            </template>
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp,baseApp,file_url,baseVersion,file_root} from "@/utils/baseUrl";

    export default {
        name: "DetailPage",
        components: {},
        props:{
            data:{
                type:Object,
                required:true
            }
        },
        data() {
            return {
                canEdit:true,
                disabled:false,
                baseerp:'',
                file_root:'',
                formData:{},
                id:0,
                gszList:[]
            }
        },
        watch: {
            data: {
                handler() {
                    this.id=this.data.id
                    if(this.id==0){
                        this.selectGsz()
                    }else{
                        this.pzsupplierDetail()
                    }
                },
                immediate: true,
                deep: true
            },
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.baseerp=baseerp;
            this.file_root=file_root;
            this.getDateYYYYMMddHHMMSS();
            this.formData.lruname=sessionStorage.getItem("lruname");
            this.formData.lruid=sessionStorage.getItem("userid");
            this.$nextTick(()=>{
                this.onResize();
            })
        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-20;
                if(this.tableHeight<60)this.tableHeight=60;
            },

            saveForm(){
                if(this.formData.pzcode==''){
                    this.$message.warning('请填写品种代码')
                    return
                }
                if(this.formData.supplier=='' || this.formData.suppliercode==''){
                    this.$message.warning('请填写厂家信息')
                    return
                }
                if(this.formData.gid==''){
                    this.$message.warning('请选择归属组')
                    return
                }
                this.disabled=true;
                this.savePzsupplier()
            },

            cancel(){
                this.$emit('close')
            },
            async selectGsz(){
                let param={};
                let res=await API.selectGsz(param);
                if ( res.code == 1 ){
                    this.gszList=res.data

                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async pzsupplierDetail(){
                let param={
                    id:this.id
                };
                let res=await API.pzsupplierDetail(param);
                if ( res.code == 1 ){
                    this.formData=res.data;
                    this.selectGsz()
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async savePzsupplier(){
                this.formData.id = this.id;
                let param=this.formData;
                // return
                let res=await API.savePzsupplier(param);
                if ( res.code == 1 ){
                    this.$emit('close','save');
                    this.disabled=false
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                    this.disabled=false
                }
            },

            //获取当天日期时间
            getDateYYYYMMddHHMMSS(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份
                const strDate = date.getDate().toString().padStart(2, '0'); // 日期
                var hour = date.getHours();       // 获取当前小时数(0-23)
                var minute = date.getMinutes();   // 获取当前分钟数(0-59)
                var second = date.getSeconds();   // 获取当前秒数(0-59)
                this.formData.createtime=`${date.getFullYear()}-${month}-${strDate} ${hour}:${minute}:${second}`;
            },
        },
    }
</script>

<style lang="scss" scoped>
    .flex{
        display:flex;
    }
    /deep/.borderred .el-input__inner{
        border-color: red ;
    }
    .jcsb{
        justify-content: space-between;

    }
    .el-form-item__content .el-input,.el-form-item__content .el-input-number,.el-form-item__content .el-select{
        width: 150px;
    }
    .uploadfile1{
        position: absolute;
        opacity: 0;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
    }
    .el-form-item div{
        display: inline-block;
        padding-right: 30px;
    }
</style>